<template>
  <div class="purchase__slot">
    <h1 class="purchase__slot--title">Débloquer un encart</h1>
    <h3 class="purchase__slot--text">
      Vous vous disposez de
      <span class="purchase__slot--highlight">{{ userInfo.credits }}</span>
      crédits
    </h3>
    <div
      v-if="userInfo.credits >= minimumCredits"
      class="purchase__slot--available"
    >
      <p>
        Voulez-vous vraiment débloquer cet encart ? il vous coûtera
        {{ minimumCredits }} crédits
      </p>
      <base-button class="purchase__slot--button" @click.native="purchaseSlot"
        >Confirmer l'achat</base-button
      >
    </div>
    <div v-else class="purchase__slot--unavailable">
      <p>
        Vous n'avez pas assez de crédits pour débloquer cet encart ?
        <br />
        nous vous invitons à vous rediriger vers la page d'achat de crédits
      </p>
      <base-button
        class="purchase__slot--button"
        @click.native="$router.push('/packs')"
        >Aller à la page d'achat de crédits</base-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import {
  purchasePremiumSlot,
  getAllUserPlannings as fetchPlannings
} from "@/api/plannings"
import { Message } from "element-ui"
export default {
  data: () => ({
    minimumCredits: 0,
    planning_infos: null
  }),
  computed: {
    ...mapGetters(["userInfo", "modal"])
  },
  created() {
    this.planning_infos = this.modal.payload.planning.infos
    this.minimumCredits = this.planning_infos.slot_price
  },
  methods: {
    async purchaseSlot() {
      const { planning_id } = this.modal.payload.planning.infos
      const { message } = await purchasePremiumSlot(planning_id)
      await this.$store.dispatch("getInfo")
      await fetchPlannings(this.userInfo.id)
      Message.success(message)
      this.$store.dispatch("closeModal", {
        name: "purchase-slot"
      })
      this.$root.$emit("slotPurchased")
      // this.$router.go()
      // this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.purchase__slot {
  padding: 30px 50px;
  min-width: 600px;
  &--highlight {
    color: $color-secondary--dark;
  }
  &--title {
    font-size: 2.5em;
  }
  &--button {
    margin-top: 25px;
  }
}
</style>
